export default __webpack_public_path__ + "static/media/flow_2.7d3814df.jpg";